import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {setErrorAction} from "../store/reducers/commonSlice";
import {AuthService} from "../services/AuthService";
import endpoints from "../endpoints";
import IPage from "../types/page";
import IEmail from "../types/email";
import ILog from "../types/log";

interface IGetAllRequest {
    sort: string
    order: 'desc' | 'asc'
    tag?: string,
    dateFrom?: string,
    dateTo?: string
}

export const logAPI = createApi({
    reducerPath: 'logAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: `${endpoints.api}/logs`,
        prepareHeaders: (headers: Headers) => {
            const token = AuthService.getToken() || ''
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
        }
    }),
    endpoints: (builder) => ({
        getAll: builder.query<ILog[], IGetAllRequest>({
            query: (sortingData) => {
                return {
                    url: '',
                    method: 'GET',
                    params: sortingData
                }
            }
        })
    })
})